import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getSubFamiliaList, modifySubFamilia, removeSubFamilia, addSubFamilia, updateSubFamiliaDB } from '../../actions/sub_familia_actions';
import { getFamilia } from '../../actions/familia_actions'

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';


import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    marginBottom: {
        marginBottom: 20,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresSubFamilia extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getFamilia();
        this.props.getSubFamiliaList();
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkCvSubFamilia = (subFamilia) => {
        if (this.props.subFamiliaList.find(sf => (sf.descr === subFamilia.descr) && (sf.id !== subFamilia.id))) {
            this.messageDialog(`Ya existe una subfamilia con descripción ${subFamilia.descr}`);
            return false;
        } else if (!subFamilia.descr.trim()) {
            this.messageDialog('Por favor, introduzca una descripción');
            return false;
        } else if (!subFamilia.cod.trim()) {
            this.messageDialog('Por favor, introduzca un código');
            return false;
        } else if (this.props.subFamiliaList.find(sf => (sf.cod === subFamilia.cod) && (sf.id !== subFamilia.id))) {
            this.messageDialog(`Ya existe una subfamilia con código ${subFamilia.cod}`);
            return false;
        }

        else return true;
    };

    editSubFamilia = (subFamilia) => {

        this.props.openDialog('EditCvSubFamilia', {
            subFamilia: subFamilia,
            checkSubFamilia: this.checkCvSubFamilia,
            okHandler: (sf) => {
                this.props.setSaveState(true);
                this.props.modifySubFamilia(sf);
            },
            familiaList: this.props.familiaList

        }, uuidv4());
    };

    newSubFamilia = () => {
        this.props.openDialog('EditCvSubFamilia', {
            subFamilia: {},
            checkSubFamilia: this.checkCvSubFamilia,
            okHandler: (tp) => {
                this.props.setSaveState(true);
                this.props.addSubFamilia(tp);
            },
            familiaList: this.props.familiaList
        }, uuidv4());
    };

    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {

        for (let i = fromRow; i <= toRow; i++) {
            let updatedRow = update(this.props.subFamiliaList[i], { $merge: updated });
            if (this.checkCvSubFamilia(updatedRow)) {
                this.props.setSaveState(true);
                this.props.modifySubFamilia(updatedRow);
            }
        }

    };

    handleDeleteRow = (subFamilia) => {
        this.props.setSaveState(true);
        this.props.removeSubFamilia(subFamilia);
    };

    render() {

        const { classes } = this.props;



        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div className={classes.marginBottom}>
                    <NeuriteGrid
                        id="m_r_s_f"
                        columns={[
                            { key: 'familiaDescr', name: 'Familia', editable: false, dragable: false, width: 250 },
                            { key: 'descr', name: 'Sub Familia', editable: false, dragable: false, width: 250 },
                            { key: 'cod', name: 'Código', editable: false, dragable: false, width: 60 }
                        ]}
                        rows={this.props.subFamiliaList}
                        height={500}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newSubFamilia}
                        onEditClick={this.editSubFamilia}
                        // onRowsUpdated={this.handleGridRowsUpdated}
                        onDeleteClick={this.handleDeleteRow}

                    />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.subFamiliaList.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateSubFamiliaDB(this.props.subFamiliaList)
                }
                }>Guardar</Button>
            </div>
        );

    };

};

MaeAuxiliaresSubFamilia.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    subFamiliaList: PropTypes.array.isRequired,
    familiaList: PropTypes.array.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getFamilia: PropTypes.func.isRequired,
    getSubFamiliaList: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifySubFamilia: PropTypes.func.isRequired,
    removeSubFamilia: PropTypes.func.isRequired,
    addSubFamilia: PropTypes.func.isRequired,
    updateSubFamiliaDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        subFamiliaList: state.subFamilia.subFamiliaList,
        familiaList: state.familia.familias,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getSubFamiliaList,
        getFamilia,
        openDialog,
        hideDialog,
        modifySubFamilia,
        removeSubFamilia,
        addSubFamilia,
        updateSubFamiliaDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresSubFamilia));

